<template>
	<div class="footers" :class="{'newV-footers': (vipState === 0 || vipState === 'loginNo')}">
		<div class="footer-bg"></div>
		<p class="footer-con">开启应聘快车道，与众不同立即开始</p>
	</div>
</template>

<script>
export default {
	name: 'footers',
	props: ['vipState'],
}
</script>

<style lang="scss" scope>
	.footers {
		padding: 50px 0 50px;
		background: #f6f6f6;
	}
	//新版非会员样式
	.newV-footers{
		background: transparent;
		position: absolute;
		bottom: 0;
		margin: 0 auto;
		left: 0;
		right: 0;
		opacity: .3;
	}
	.footer-bg {
		margin: 0 auto 10px;
		width: 200px;
		height: 30px;
		background: url(../../../../assets/imgs/footer-bg.png);
		background-size: 100% 100%;
	}
	.footer-con {
		font-size: 14px;
		color: #C3C3C3;
		text-align: center;
		opacity: .6;
	}
</style>



// WEBPACK FOOTER //
// Footer.vue?47295ca4